// Stimulus Controller for Auction Countdown Timer
// Usage: <div data-controller="auction-timer" data-auction-timer-ends-at-value="2024-01-20T15:00:00Z">

import { parseTimeRemaining, formatTimeRemaining, getUrgencyLevel, padZero } from '../utils/timer_helpers'

export default class AuctionTimerController {
  static values = {
    endsAt: String,
    warningThreshold: { type: Number, default: 300 }, // 5 minutes
    urgentThreshold: { type: Number, default: 120 }   // 2 minutes (sniping protection)
  }

  static targets = ['days', 'hours', 'minutes', 'seconds', 'display']

  connect() {
    this.startTimer()
    this.listenForUpdates()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.updateDisplay()
    this.intervalId = setInterval(() => this.updateDisplay(), 1000)
  }

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  listenForUpdates() {
    // Listen for time updates from ActionCable
    document.addEventListener('auction:time-update', (event) => {
      this.endsAtValue = event.detail.ends_at
    })
  }

  updateDisplay() {
    const endsAt = new Date(this.endsAtValue)
    const now = new Date()
    const diff = Math.max(0, endsAt - now)

    if (diff === 0) {
      this.showEnded()
      this.stopTimer()
      return
    }

    const { days, hours, minutes, seconds } = parseTimeRemaining(diff)
    const totalSeconds = diff / 1000

    // Update individual targets if they exist
    if (this.hasDaysTarget) this.daysTarget.textContent = days
    if (this.hasHoursTarget) this.hoursTarget.textContent = padZero(hours)
    if (this.hasMinutesTarget) this.minutesTarget.textContent = padZero(minutes)
    if (this.hasSecondsTarget) this.secondsTarget.textContent = padZero(seconds)

    // Update full display target if it exists
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = formatTimeRemaining(days, hours, minutes, seconds)
    }

    // Update urgency classes
    this.updateUrgencyClass(totalSeconds)
  }

  updateUrgencyClass(totalSeconds) {
    const element = this.element
    const level = getUrgencyLevel(totalSeconds, this.warningThresholdValue, this.urgentThresholdValue)

    element.classList.remove('timer-normal', 'timer-warning', 'timer-urgent')
    element.classList.add(`timer-${level}`)
  }

  showEnded() {
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = 'Ended'
    }
    this.element.classList.add('timer-ended')
  }
}

// Register with Stimulus if using standard setup
if (typeof window.Stimulus !== 'undefined') {
  window.Stimulus.register('countdown', AuctionTimerController)
}
